import { Component } from '@angular/core';

@Component({
    selector: 'app-social-linkedin',
    templateUrl: './social-linkedin.component.html',
    standalone: false
})
export class SocialLinkedinComponent {
}
